import { DomainModelHelper } from '@digital-platform/shared/domain';
import { WasteProfileStatus } from '../enums';
import { InternalStatusHistory } from '../interfaces';

export class InternalStatusHistoryModel implements InternalStatusHistory {
  readonly id: string | null;
  readonly version: number | null;
  readonly date: Date;
  readonly status: WasteProfileStatus | null;
  readonly internalStatus: string | null;
  readonly userName: string;
  readonly type: 'new' | 'recertify' | 'change' | 'recertify-change' | null;

  public static DEFAULT_CONFIG: InternalStatusHistory = {
    id: null,
    version: null,
    date: new Date(),
    status: null,
    internalStatus: null,
    userName: '',
    type: 'new',
  };

  public static hydrate(data: InternalStatusHistory): InternalStatusHistory {
    return {
      id: DomainModelHelper.ensureDataIsString(data.id),
      version: DomainModelHelper.ensureDataIsNumber(data.version),
      date: DomainModelHelper.ensureDataIsDate(data.date),
      status: data.status,
      internalStatus: DomainModelHelper.ensureDataIsString(data.internalStatus),
      userName: DomainModelHelper.ensureDataIsString(data.userName),
      type: InternalStatusHistoryModel.convertToType(data.type),
    };
  }

  private static convertToType(
    value: string
  ): InternalStatusHistoryModel['type'] {
    value = value || '';
    switch (value.toLocaleLowerCase()) {
      case 'new':
        return 'new';
      case 'recertify':
        return 'recertify';
      case 'change':
        return 'change';
      case 'recertify-change':
        return 'recertify-change';
      default:
        return null;
    }
  }
}
